import Image from "next/image";
import { useRouter } from "next/router";
import Meta from "../../components/Meta"; // Assuming Meta component exists

const Blog_ArtForImpact = () => {
  const router = useRouter();
  // In a real application, you might use router.query to fetch specific blog data
  // For this example, we'll use hardcoded data
  const blogPostData = {
    id: "art-for-impact",
    image: "/images/new/2.png", // Placeholder image, replace with an actual path
    title: "Art for Impact: Creativity for People and the Planet",
    date: "June 28, 2025",
    time: "8 min read", // Estimated read time
    authorImage: "/images/avatars/avatar_2.jpg", // Placeholder image, replace with an actual author image
    authorName: "Impactoverse Team",
    category: "Art & Impact",
    subCategory: "Social Good",
  };

  return (
    <div>
      <Meta title={`${blogPostData.title} || Impactoverse`} />

      <div className="pt-[5.5rem] lg:pt-24">
        <section className="relative py-16 md:py-24">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
            <Image
              width={1519}
              height={773}
              priority
              src="/images/gradient_light.jpg"
              alt="gradient"
              className="h-full w-full object-cover"
            />
          </picture>
          <div className="container" key={blogPostData.id}>


            <figure className="mb-16">
              <Image
                width={900}
                height={400}
                priority
                src={blogPostData.image}
                alt="post image"
                className="rounded-2xl object-cover mx-auto"
              />
            </figure>
           
            <article className="mb-12">
              <div className="article-content">
                <div className="mx-auto mb-16">

                  <h2 className="font-display text-3xl text-jacarta-700 dark:text-white mb-8">
                    Art for Impact: Creativity for People and the Planet
                  </h2>
                </div>
                <p className="text-lg ">
                  Art has always been a powerful medium for storytelling,
                  self-expression, and community building. But what if art
                  could do even more? At Impactoverse, we’re creating a means
                  for artists and changemakers around the world to use
                  creativity as a force to drive social good, raising funds for
                  impactful, vetted projects that changes lives and protects the
                  planet. From providing food security to orphanages through
                  sustainable gardening initiatives to ensuring safe school
                  transportation for children walking hours to their classrooms,
                  the fusion of art and impact is creating tangible solutions
                  where they are needed most.
                </p>
                <h2 className="text-lg font-bold mt-8 mb-4">
                  The Power of Art for Fundraising
                </h2>
                <p className="text-lg ">
                  Art has an emotional pull that few other mediums can match.
                  Whether through paintings, digital creations, sculptures, or
                  immersive experiences, art captures attention and inspires
                  action. By purchasing or contributing artwork, individuals are
                  not just acquiring a piece of creativity but actively funding
                  projects that bring about real change. These initiatives
                  bridge the gap between art enthusiasts and communities in
                  need, offering a direct and transparent way to support
                  meaningful causes.
                </p>
                <p className="mt-4 text-lg">
                  Here are just some of the projects that are making a
                  difference!
                </p>

                <h2 className="text-lg font-bold mt-8 mb-4">Food Security</h2>
                <p className="text-lg ">
                  Esther’s Orphanage in Uganda struggles with food insecurity,
                  relying on inconsistent donations to sustain children. Through
                  art sales and donations, funds can be raised to build gardens
                  and implement technology-driven solutions like hydroponics and
                  aquaponics to grow sustainable crops year-round. This will
                  empower the orphanage to become self-sufficient while teaching
                  children valuable agricultural skills.
                </p>

                <h2 className="text-lg font-bold mt-8 mb-4">
                  Providing School Transportation for Young Children
                </h2>
                <p className="text-lg ">
                  At Glorious Foundation school in Tanzania, children as young
                  as five walk up to three hours each day to get to school. A
                  campaign powered by art contributions will help raise funds to
                  purchase a school bus, ensuring that children arrive at school
                  safely and ready to learn, ultimately improving their
                  educational outcomes and well-being.
                </p>

                <h2 className="text-lg font-bold mt-8 mb-4">
                  Art for Wellbeing and Mental Health
                </h2>
                <p className="text-lg ">
                  Art has the ability to heal, uplift, and bring hope. The
                  Positive Vibes campaign through Aunua Global in Ireland aims
                  to leverage artistic expression to support mental health
                  programmes for youth. From murals to interactive workshops,
                  art can create environments that promote well-being and
                  resilience while raising funds to sustain these initiatives.
                </p>

                <h2 className="text-lg font-bold mt-8 mb-4">
                  Water for Life: Protecting Rivers and Oceans
                </h2>
                <p className="text-lg ">
                  Clean water is essential for life, yet plastic pollution and
                  environmental degradation threaten vital waterways. Think
                  Ocean CIC in the UK and the ROLE Foundation in Bali raises
                  funds through art to support riverbank and beach cleanups,
                  preventing plastic pollution from reaching the ocean.
                  Additionally, funds contribute to coral restoration projects,
                  rebuilding damaged reefs and protecting marine biodiversity.
                  Education and awareness campaigns funded by art sales help
                  communities understand the importance of water conservation,
                  inspiring long-term action and sustainability.
                </p>

                <h2 className="text-lg font-bold mt-8 mb-4">
                  How You Can Get Involved
                </h2>
                <ol className="list-decimal list-inside space-y-3 text-lg">
                  <li>
                    <b>Purchase Art:</b> Every piece of art sold directly funds
                    critical impact projects. Buyers don’t just receive a
                    creative token of impact but also the satisfaction of
                    knowing their contribution is making a real difference.
                  </li>
                  <li>
                    <b>Contribute Your Art:</b> You can donate a photo, drawing
                    or other artwork to be sold in support of these vetted
                    projects, expanding the reach and effect of campaigns.
                  </li>
                  <li>
                    <b>Share and Advocate:</b> Spreading awareness is just as
                    impactful as donating. Share these initiatives with your
                    network and help amplify the mission.
                  </li>
                </ol>

                <h2 className="text-lg font-bold mt-8 mb-4">
                  Transparency and Impact Tracking
                </h2>
                <p className="text-lg">
                  Ensuring transparency is key to maintaining trust and
                  accountability. Each funded project is trackable, allowing
                  contributors to see the direct impact of their support. Regular
                  updates, financial breakdowns, and success stories provide
                  clarity and proof that funds spent are creating change.
                </p>

                <blockquote className="text-jacarta-700 !my-10 text-lg italic dark:text-white">
                  “Art transcends borders, languages, and cultures, making it a
                  universal tool for positive impact.”
                  <cite className="text-jacarta-400 text-2xs mt-3 block not-italic tracking-tight">
                    — Impactoverse Team
                  </cite>
                </blockquote>

                <h2 className="text-lg font-bold mt-8 mb-4">
                  Art as a Universal Force for Good
                </h2>
                <p className="text-lg">
                  Whether you are an artist, a collector, or simply someone who
                  believes in making the world a better place, there is a role
                  for you in this movement. By turning creativity into
                  actionable change, we can uplift communities, provide
                  essential resources, and create sustainable solutions for
                  generations to come.
                </p>
                <p className="mt-4 text-lg">
                  Join the movement. Support. Create. Share. Make an impact.
                  Everyone wins.
                </p>
              </div>
            </article>

           
          </div>
        </section>
      </div>
    </div>
  );
};

export default Blog_ArtForImpact;